// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__tgkuX","navBtn":"sidebar_navBtn__-EZZ9"};